import clsx from 'clsx'
import geolib from 'geolib'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import Accordion from 'components/common/accordion'
import SnackBar from 'components/common/snack-bar'
import PomeloPickUpDetailModal from 'components/modal/pomelo-pickup-detail-modal'
import BackdropModal from 'components/portal/backdrop-modal'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import Utils from 'lib/utils'
import PickupDetail from '../pickup-detail'
import SearchInput from './search-input'

import styles from './style.scss'

class LocationFilter extends React.PureComponent {
  state = {
    showDetailsModal: null,
    showErrorMessage: false,
    showNoLocation: false,
  }

  showSelectedLocation = (location) => {
    const { selectedLocation, setSelectedLocation } = this.props
    // const { showErrorMessage, showNoLocation } = this.state
    const isSelectedLocation = this.isSelectedLocation(
      location,
      selectedLocation,
    )

    if (isSelectedLocation) {
      setSelectedLocation()
    } else {
      setSelectedLocation(location)
    }
  }

  isSelectedLocation = (location, selectedLocation) => {
    if (selectedLocation && location) {
      if (
        selectedLocation.id_partner_store &&
        location.id_partner_store &&
        selectedLocation.id_partner_store === location.id_partner_store
      ) {
        return true
      }

      if (
        selectedLocation.id_pickup_location &&
        location.id_pickup_location &&
        selectedLocation.id_pickup_location === location.id_pickup_location
      ) {
        return true
      }
      return false
    }
    return false
  }

  hideDetailsModal = (e) => {
    if (e?.preventDefault) {
      /* istanbul ignore next */
      e.preventDefault()
    }

    this.setState({ showDetailsModal: null })
  }

  handleAccordionClick = (e, location, locationId) => {
    e.preventDefault()
    e.stopPropagation()

    const { isPhone } = this.props

    if (isPhone) {
      this.setState({ showDetailsModal: locationId })
    } else {
      this.showSelectedLocation(location)
    }

    this.scrollToChosenList(locationId)
  }

  renderLocation = (location) => {
    const { t, selectedLocation, isPhone } = this.props
    const { showDetailsModal } = this.state
    const isSelectedLocation = this.isSelectedLocation(
      location,
      selectedLocation,
    )
    let distance_from_user = (location && location.distance_from_user) || 0

    if (distance_from_user) {
      if (distance_from_user < 0.5) {
        distance_from_user = '0.5 km'
      } else if (distance_from_user < 5) {
        distance_from_user = `${Math.round(distance_from_user)} km`
      } else if (distance_from_user < 50000) {
        distance_from_user = null
      } else {
        distance_from_user = 'N/A'
      }
    }

    const infoContainerClassName = clsx('lfc__pickup-lists', {
      'hightlight-content': isPhone && isSelectedLocation,
    })

    const locationId = `${location.id_pickup_location}-${
      location.id_partner_store || ''
    }`

    return (
      <React.Fragment>
        <Accordion
          isExpanded={isSelectedLocation}
          onClick={
            isPhone
              ? /* istanbul ignore next */ (e) =>
                  this.handleAccordionClick(e, location, locationId)
              : undefined
          }
          key={locationId}
          id={`accordion__title-${locationId}`}
          title={
            <div
              className={infoContainerClassName}
              onClick={(e) =>
                this.handleAccordionClick(e, location, locationId)
              }
              onKeyUp={(e) =>
                this.handleAccordionClick(e, location, locationId)
              }
              role="button"
              tabIndex="0"
            >
              <div className="lfc__information-area">
                <span className={clsx(Typo.caption, 'lfc__pickup-district')}>
                  {t(location.district)}
                </span>
                <span className={clsx(Typo.subtitle2, 'lfc__pickup-alias')}>
                  {t(location.alias)}
                </span>
                <span className={Typo.body2}>
                  {t(location.subtype || location.type)}
                </span>
              </div>
              <div className="lfc__icon-area">
                {!!distance_from_user && (
                  <span className={clsx(Typo.caption, 'lfc__distance')}>
                    {distance_from_user}
                  </span>
                )}
              </div>
            </div>
          }
          withArrow
        >
          {!isPhone && <PickupDetail location={location} t={t} />}
        </Accordion>

        {isPhone && (
          <BackdropModal
            onBackdropClick={this.hideDetailsModal}
            isOpen={showDetailsModal === locationId}
            zIndex={10000} // override coach mark zIndex
          >
            <PomeloPickUpDetailModal
              close={this.hideDetailsModal}
              location={location}
              t={t}
            />
          </BackdropModal>
        )}
      </React.Fragment>
    )
  }

  scrollToChosenList = (id) => {
    const { isPhone } = this.props
    const chosenElement = document.getElementById(`accordion__title-${id}`)
    const googleMapFilterArea = document.getElementById(
      'gmsfc__map-filter-area',
    )

    if (isPhone) {
      const locationFilterContainer = document.getElementById(
        'location-filter-component',
      )
      locationFilterContainer.scrollIntoView(true)
    }

    // Only activate scroll to with the expanding action.
    if (chosenElement) {
      chosenElement.scrollIntoView(true)
      googleMapFilterArea?.scrollIntoView(true)
    }
  }

  geoUpdate(coords, allPins) {
    // Reset location to default, when user click on input clear
    this.setState({
      showErrorMessage: false,
      showNoLocation: false,
    })

    const { maxFilteredData } = this.props
    const { setSelectedLocation, setFilteredLocation, setSearchedLocation } =
      this.props

    if (!coords) {
      setSelectedLocation()
      setFilteredLocation()
      setSearchedLocation()
      return
    }

    const currentLocation = {
      latitude: coords.latitude,
      longitude: coords.longitude,
    }
    let parsedPins =
      allPins &&
      allPins.map((pin) => {
        let distanceFromUser = 50000 // Earth length is 40,008 km around

        if (
          (pin.latitude || pin.latitude === 0) &&
          (pin.longitude || pin.longitude === 0)
        ) {
          // Convert unit from meter to kilometer
          distanceFromUser =
            geolib.getDistance(currentLocation, {
              latitude: pin.latitude,
              longitude: pin.longitude,
            }) / 1000
        }

        return { ...pin, distance_from_user: distanceFromUser }
      })

    parsedPins = Utils.sortPomeloPins(parsedPins)

    if (
      maxFilteredData !== 'all' &&
      !Number.isNaN(parseInt(maxFilteredData, 10))
    ) {
      parsedPins = parsedPins.slice(0, maxFilteredData)
    }

    // The first pin is the closest pin.
    // And we only sort and show the distance if the nearest pin is closer or equal to 5 km.
    if (
      parsedPins &&
      parsedPins.length > 0 &&
      parsedPins[0].distance_from_user <= 5
    ) {
      setFilteredLocation(parsedPins)
      setSearchedLocation(currentLocation)
    } else {
      this.setState({ showNoLocation: true })
      setFilteredLocation()
    }
  }

  render() {
    const {
      t,
      isPhone,
      filteredLocations,
      locations,
      selectedLocation,
      setCurrentLocation,
      showCoachMark,
      setCoachMark,
    } = this.props

    const { showErrorMessage, showNoLocation } = this.state

    let locationData = filteredLocations || locations

    if (isPhone && selectedLocation) {
      locationData = locationData.filter(
        (data) => !this.isSelectedLocation(data, selectedLocation),
      )
      locationData.unshift(selectedLocation)
    }

    return (
      <div className="location-filter-component" id="location-filter-component">
        <style jsx>{styles}</style>
        <SearchInput
          geoUpdate={(geoData) => this.geoUpdate(geoData, locationData)}
          showUnavailable={() => this.setState({ showErrorMessage: true })}
          t={(msg) => t(msg)}
          isPhone={isPhone}
          setCurrentLocation={setCurrentLocation}
          showCoachMark={showCoachMark}
          setCoachMark={setCoachMark}
        />
        <div className="lfc__locations">
          {(showErrorMessage || showNoLocation) && (
            <div className="lfc__error-message-container">
              <SnackBar duration={10000} open={showErrorMessage}>
                <span>{t('Location not found.')}</span>
              </SnackBar>
              <SnackBar duration={10000} open={showNoLocation}>
                <span>
                  {t(
                    'Oops. There is no available Pomelo location on that area. Why don`t you try one of these locations?',
                  )}
                </span>
              </SnackBar>
            </div>
          )}

          {locationData?.map(this.renderLocation)}
        </div>
      </div>
    )
  }
}

LocationFilter.defaultProps = {
  filteredLocations: [],
  isPhone: false,
  maxFilteredData: 'all',
  selectedLocation: null,
  showCoachMark: false,
}

LocationFilter.propTypes = {
  filteredLocations: PropTypes.arrayOf(PropTypes.shape({})),
  isPhone: PropTypes.bool,
  locations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  maxFilteredData: PropTypes.string,
  selectedLocation: PropTypes.shape({}),
  setCurrentLocation: PropTypes.func.isRequired,
  setFilteredLocation: PropTypes.func.isRequired,
  setSearchedLocation: PropTypes.func.isRequired,
  setSelectedLocation: PropTypes.func.isRequired,
  showCoachMark: PropTypes.bool,
  setCoachMark: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

const Extended = withI18next()(LocationFilter)

export default connect((state) => ({
  isPhone: state.device.isPhone,
}))(Extended)
